import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Layout, Modal, Select, SelectProps } from 'antd';
import './style.css';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import CardComponentAttachedFile from '../../cards/cardComponentAttachedFile/CardComponentAttachedFile';
import { useSelectedFile } from '../../../store/devices/getSelectedFile';
import { format, parseISO } from 'date-fns';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import AttachFile from '../attachFiles/attachFile';
import { ReactComponent as TooltipIcon } from 'utils/app/assets/icons/Tooltip-support.svg';
import { useAttachedFilesByUidStore } from '../../../store/attachedFiles/attachedFilesByUid';
import Player from '../../player/Player';
import { FILE_PLAY_URL } from '../../../const/const';
import { useAuthStore } from '../../../store/auth/auth';
import { Content } from 'antd/es/layout/layout';
import { Footer } from 'antd/lib/layout/layout';
import { formatDuration } from '../../../utils/shared/helpers/formatDuration';
import { useOnlineStateStream } from '../../../store/devices/onlineStream';
import { isPTTMessage } from '../../../pages/pagesV2/archive/components/ArchiveSearchPanel/helpers/consts/consts';
import Tag from '../../../utils/shared/components/Tags/Tag';
import {
    formatDateTime,
    safeTimestampTwo,
} from '../../../pages/pagesV2/pttDispatcher/helpers/formatDateTime';
import usePTTMessageStore from '../../../pages/pagesV2/pttDispatcher/api/usePttMessageStore';
import { updateFileCase, updateFileRating } from '../../../api/file/updateFile';
import { useFilesStore } from '../../../store/devices/FilesDevicesFromDB';

interface MoreDetailsProps {
    open: boolean;
    onOk: () => void;
    onCancel: () => void;
}

const options: SelectProps['options'] = [
    { label: '1 - наименьшая секретность', value: '0' },
    { label: '2 - низкая секретность', value: '1' },
    { label: '3 - средний уровень секретности', value: '2' },
    { label: '4 - повышенная секретность', value: '3' },
    { label: '5 - высокая секретность', value: '4' },
];

const MoreDetails: React.FC<MoreDetailsProps> = ({ open, onOk, onCancel }) => {
    const { selectedFile, setSelectedFile, updateSelectedFile } = useSelectedFile();
    const { user, SmartDVRToken } = useAuthStore();
    const audioRefs = useRef<{ [key: string]: HTMLAudioElement | null }>({});
    const { messages, markMessageAsPlayed, loadAudioBlob, resetUnread } = usePTTMessageStore();
    const { updateSingleFileInStore } = useFilesStore();
    const { files, fetchFiles, resetFiles, hasMore, pagination, setPagination } = useFilesStore();

    const [form] = Form.useForm();
    console.log('selectedFile', selectedFile);
    const getFilePlayUrl = () => {
        if (user && SmartDVRToken) {
            return `${FILE_PLAY_URL}${selectedFile.UID}`;
        }
        return '';
    };
    const formatDate = (isoDate: string, hoursAdd?: boolean): string => {
        if (hoursAdd) {
            const parsedDate = parseISO(isoDate);
            const adjustedDate = new Date(parsedDate.getTime() - 5 * 60 * 60 * 1000);
            return format(adjustedDate, 'dd.MM.yy - HH:mm:ss');
        }
        const parsedDate = parseISO(isoDate);
        return format(parsedDate, 'dd.MM.yy - HH:mm:ss');
    };

    const handleCancel = () => {
        // Сбрасываем выбранный файл при закрытии
        setSelectedFile(null);
        onCancel();
    };

    const [size] = useState<SizeType>('middle');
    const [openAttacheFiles, setOpenAttacheFiles] = useState(false);
    const { AttachedFilesByUid, fetchAttachedFilesByUid } = useAttachedFilesByUidStore();

    let displayDate;

    // Для сброса формы
    useEffect(() => {
        form.resetFields();
    }, [selectedFile]);

    useEffect(() => {
        if (selectedFile && !isPTTMessage(selectedFile)) {
            fetchAttachedFilesByUid(selectedFile.UID);
        }
    }, [selectedFile]);
    // displayDate = formatDate(selectedFile.)
    console.log(selectedFile);
    if (selectedFile && isPTTMessage(selectedFile)) {
        return (
            <Modal
                className={'DrawerMoreDetailsM4 archive'}
                closable={false}
                // style={{
                //     top: 24,
                //     bottom: 92,
                //     maxHeight: 'calc(100vh - 24px - 92px)',
                // }}

                title={
                    <span className="titleModal">
                        <div className="title0">
                            <div className="title1">
                                {formatDate(safeTimestampTwo(selectedFile.timestamp), true)}
                                {/*    <span*/}
                                {/*        className={'title large'}*/}
                                {/*        style={{ color: 'var(--gray-01)', marginLeft: 8 }}*/}
                                {/*    >*/}
                                {/*        ({formatDuration(selectedFile.duration)})*/}
                                {/*    </span>*/}
                                {/*)}*/}
                            </div>
                        </div>
                        <CloseOutlined
                            className="closeBut2"
                            onClick={onCancel}
                            style={{ cursor: 'pointer', marginRight: 0 }}
                        />
                    </span>
                }
                footer={false}
                onClose={onCancel}
                centered={true}
                open={open}
                width={464}
                height={'auto'}
            >
                <div className="LR_MD">
                    <Layout>
                        <div className="title2" style={{ marginTop: 0, marginBottom: 8 }}>
                            {/*<div className="title3">{selectedFile.size.toFixed(1)} мБ </div>*/}
                            {/*<div*/}
                            {/*    style={{*/}
                            {/*        marginLeft: 10,*/}
                            {/*        width: 2,*/}
                            {/*        color: 'var(--divider-1)',*/}
                            {/*        position: 'relative',*/}
                            {/*        bottom: 5,*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    |*/}
                            {/*</div>*/}
                            <div className={'body large'} style={{ color: 'var(--gray-01)' }}>
                                {selectedFile.sender.name} - {selectedFile.recipient.name}
                            </div>
                        </div>
                        <div
                            style={{
                                borderBottom: '2px solid var(--divider-2)',
                                paddingBottom: 22,
                                marginBottom: 24,
                            }}
                        >
                            <Tag border={true} state={'default'}>
                                {selectedFile.group?.name}
                            </Tag>
                        </div>
                        <Content className="content-RMD">
                            <div className="right_MD">
                                <div className="left_MD">
                                    <audio
                                        style={{ width: '100%' }}
                                        // ref={(el) => (audioRefs.current[selectedFile.id] = el)}
                                        controls
                                        src={
                                            selectedFile.audioBlobUrl || selectedFile.audioUrl || ''
                                        }
                                        // onPlay={() => {
                                        //     if (selectedFile.direction === 'incoming') {
                                        //         markMessageAsPlayed(selectedFile.id);
                                        //     }
                                        // }}
                                        // onError={() => {
                                        //     if (
                                        //         !selectedFile.audioBlobUrl &&
                                        //         selectedFile.audioUrl
                                        //     ) {
                                        //         loadAudioBlob(
                                        //             selectedFile.id,
                                        //             user?.login!,
                                        //             SmartDVRToken,
                                        //         );
                                        //     }
                                        // }}
                                        autoPlay={true}
                                    />
                                </div>
                            </div>
                        </Content>
                        <Footer style={{ background: '#ffff' }}>
                            <Button
                                className="button-base button-size-medium button-type-primary"
                                style={{ width: '100%' }}
                                onClick={onOk}
                            >
                                Закрыть
                            </Button>
                        </Footer>
                    </Layout>
                </div>
            </Modal>
        );
    }

    const handleCheckboxChange = (fileId: string, checked: boolean) => {
        // Your logic for handling checkbox change
    };

    if (!selectedFile) {
        return null; // Or render a fallback UI
    }

    displayDate = formatDate(safeTimestampTwo(selectedFile.start), true);
    // displayDate = formatDate(selectedFile.start);

    const handleChangeUrgent = () => {};

    const handleAddFile = () => {
        setOpenAttacheFiles(true);
    };
    const onCloseAttachFile = () => {
        setOpenAttacheFiles(false);
    };

    const onOkAttachFile = () => {
        setOpenAttacheFiles(false);
        fetchAttachedFilesByUid(selectedFile.UID);
    };

    const onFinish = async () => {
        try {
            const values = await form.validateFields();
            console.log(values);
            if (user) {
                // Отправляем обновление рейтинга
                await updateFileRating(
                    selectedFile.UID,
                    Number(values.rating),
                    user?.login,
                    SmartDVRToken,
                );

                // Отправляем обновление данных дела
                const result = await updateFileCase(
                    selectedFile.UID,
                    Number(values.caseNumber),
                    values.caseDescription,
                    user?.login,
                    SmartDVRToken,
                );
                updateSingleFileInStore(result.data.data);
                updateSelectedFile(result.data.data);
                setSelectedFile(result.data.data);

                await new Promise((resolve) => setTimeout(resolve, 150));
                onOk();
            }
        } catch (error) {
            console.error('Ошибка при обновлении файла:', error);
            // Можно добавить уведомление об ошибке
        }
    };

    return (
        <Modal
            className={
                selectedFile.fileType === 'm4a' ? 'DrawerMoreDetailsM4' : 'DrawerMoreDetails'
            }
            closable={false}
            // style={{
            //     top: 24,
            //     bottom: 92,
            //     maxHeight: 'calc(100vh - 24px - 92px)',
            // }}

            title={
                <span className="titleModal">
                    <div className="title0">
                        <div className="title1">
                            {displayDate}{' '}
                            {selectedFile.fileType !== 'jpg' && (
                                <span
                                    className={'title large'}
                                    style={{ color: 'var(--gray-01)', marginLeft: 8 }}
                                >
                                    ({formatDuration(selectedFile.duration)})
                                </span>
                            )}
                        </div>

                        <div className="title2">
                            <div className="title3">{selectedFile.size.toFixed(1)} мБ </div>
                            <div
                                style={{
                                    marginLeft: 10,
                                    width: 2,
                                    color: 'var(--divider-1)',
                                    position: 'relative',
                                    bottom: 5,
                                }}
                            >
                                |
                            </div>
                            <div
                                className={'body large'}
                                style={{ marginLeft: 12, color: 'var(--gray-01)' }}
                            >
                                {selectedFile.creator}
                            </div>
                        </div>
                    </div>
                    <CloseOutlined
                        className="closeBut2"
                        onClick={handleCancel}
                        style={{ cursor: 'pointer', marginRight: 0 }}
                    />
                </span>
            }
            footer={false}
            onClose={handleCancel}
            centered={true}
            open={open}
            width={selectedFile.fileType === 'm4a' ? 464 : 'calc(100vw - 480px)'}
            height={selectedFile.fileType === 'm4a' ? 'auto' : 'calc(100vh - 88px)'}
        >
            <Layout style={{ background: '#ffff' }}>
                <div className={`${selectedFile.fileType !== 'm4a' ? 'LR_MD' : 'LR_MD_AUDIO'}`}>
                    {selectedFile.fileType === 'm4a' ? (
                        <></>
                    ) : (
                        <Layout>
                            <Content className="content-MD">
                                <div className="left_MD">
                                    <Player
                                        key={selectedFile.UID}
                                        source={
                                            selectedFile.fileType == 'mpd'
                                                ? selectedFile.storagePath
                                                : getFilePlayUrl()
                                        }
                                        type={selectedFile.fileType}
                                        authToken={SmartDVRToken}
                                        userLogin={user?.login!}
                                    />
                                </div>
                            </Content>
                        </Layout>
                    )}
                    <Layout
                        style={{
                            background: '#ffff',
                            width: 'auto',
                        }}
                    >
                        <Content className="content-RMD">
                            <div className="right_MD">
                                {selectedFile.fileType === 'm4a' ? (
                                    <div
                                        className={`${selectedFile.fileType === 'm4a' ? 'left_MD_AUDIO' : 'left_MD'}`}
                                    >
                                        <Player
                                            key={selectedFile.UID}
                                            // source={getFilePlayUrl()}
                                            type={selectedFile.fileType}
                                            authToken={SmartDVRToken}
                                            userLogin={user?.login!}
                                            source={selectedFile.storagePath}
                                        />
                                    </div>
                                ) : (
                                    <></>
                                )}
                                <Form
                                    className="form"
                                    name="basic"
                                    labelCol={{ span: 10 }}
                                    wrapperCol={{ span: 14 }}
                                    initialValues={{
                                        rating: selectedFile.rating?.toString(), // преобразуем число в строку для Select
                                        caseNumber: selectedFile.caseNumber,
                                        caseDescription: selectedFile.caseDescription,
                                    }}
                                    form={form}
                                    style={{ maxWidth: '100%' }}
                                    // onFinish={onFinish}
                                >
                                    <div className="fileData">
                                        <h1 className="h1_event">Сведения файла</h1>

                                        <Form.Item
                                            label={<span className="inputLabel">Секретность</span>}
                                            name="rating"
                                            rules={[{ required: false }]}
                                        >
                                            <Select
                                                className="selectUrgent"
                                                size={size}
                                                defaultValue="секретность"
                                                onChange={handleChangeUrgent}
                                                style={{ width: '100%', marginBottom: 16 }}
                                                options={options}
                                            />
                                        </Form.Item>
                                    </div>

                                    <div className="eventData">
                                        <h1 className="h1_event">
                                            Сведения события
                                            <TooltipIcon
                                                style={{
                                                    position: 'relative',
                                                    top: 4,
                                                    marginLeft: 8,
                                                }}
                                            />
                                        </h1>

                                        <Form.Item
                                            label={<span className="inputLabel">Номер</span>}
                                            name="caseNumber"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Пожалуйста, введите номер',
                                                },
                                            ]}
                                        >
                                            <Input
                                                type={'text'}
                                                onChange={(e) => {
                                                    // Разрешаем только цифры
                                                    const value = e.target.value.replace(
                                                        /[^0-9]/g,
                                                        '',
                                                    );
                                                    form.setFieldsValue({ caseNumber: value });
                                                }}
                                                className="input"
                                            />
                                        </Form.Item>

                                        <Form.Item
                                            label={<span className="inputLabel">Описание</span>}
                                            name="caseDescription"
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: 'Пожалуйста, введите описание',
                                            //     },
                                            // ]}
                                            rules={[]}
                                        >
                                            <Input className="input" />
                                        </Form.Item>
                                    </div>
                                </Form>
                                <div className="attachedFile">
                                    <div className="attachedTools">
                                        <h1 className="h1_attachedFiles">
                                            Прикреплённые файлы{' '}
                                            <span
                                                className={'title large'}
                                                style={{ color: 'var(--gray-02)' }}
                                            >
                                                ({AttachedFilesByUid.length})
                                            </span>
                                        </h1>
                                        <Button
                                            className="buttonAddFile"
                                            icon={<PlusOutlined />}
                                            onClick={handleAddFile}
                                        ></Button>
                                    </div>
                                    <div className="attachedFiles">
                                        {AttachedFilesByUid.map(
                                            (attachedFile: any, index: number) => (
                                                <CardComponentAttachedFile
                                                    key={attachedFile.ID}
                                                    file={attachedFile}
                                                    // isSelected={!!selectedFile[attachedFile.UID]}
                                                    onDeleteSuccess={() =>
                                                        fetchAttachedFilesByUid(selectedFile.UID)
                                                    }
                                                    // onCheckboxChange={handleCheckboxChange}
                                                />
                                            ),
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Content>
                        <Footer style={{ background: '#ffff' }}>
                            <Button
                                className="button-base button-size-medium button-type-primary"
                                style={{ width: '100%' }}
                                onClick={onFinish}
                                htmlType="submit"
                            >
                                Сохранить
                            </Button>
                        </Footer>
                    </Layout>
                </div>
                <AttachFile
                    onCancel={onCloseAttachFile}
                    onOk={onOkAttachFile}
                    visible={openAttacheFiles}
                />
            </Layout>
        </Modal>
    );
};

export default MoreDetails;
